import React, { useState, useEffect } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import logoFull from 'assets/images/logoDark.svg'; // Full logo (dark version for light background)
import logoSmall from 'assets/images/logoBlueFull.svg'; // Small logo icon

import { dataItemsAdmin } from 'statics/sidebardata';
import { GetUserProfile } from 'store/actions';
import { getPermissionKeyForPath, hasPermission, isSuperAdminUser } from 'utils/permissionUtils';

import './layout.css';

const Sidebar = ({ isMenuOpened }) => {
  const dispatch = useDispatch();
  const { pathname } = window.location;
  const [nestedIndex, setNestedIndex] = useState(0);
  const { userData } = useSelector(state => state.user);
  const navigate = useNavigate();
  const [sidebarAccess, setSidebarAccess] = useState(dataItemsAdmin);

  useEffect(() => {
    dispatch(GetUserProfile());
  }, []);

  // Function to filter sidebar items based on permissions
  const filterSidebarItems = (items, permissions, isSuperAdmin) => {
    return items
      .map(item => {
        if (item.nestedtab) {
          const filteredNested = item.nestedtab.filter(nested => {
            const permissionKey = getPermissionKeyForPath(nested.link);
            return hasPermission(permissions, permissionKey, 'view', isSuperAdmin);
          });
          if (filteredNested.length === 0) return null;
          return { ...item, nestedtab: filteredNested };
        }

        if (item.link) {
          const permissionKey = getPermissionKeyForPath(item.link);
          return hasPermission(permissions, permissionKey, 'view', isSuperAdmin) ? item : null;
        }

        return item;
      })
      .filter(item => item !== null);
  };

  useEffect(() => {
    const permissions = userData?.assignablePermissions || {};
    const isSuperAdmin = isSuperAdminUser(userData);

    if (isSuperAdmin) {
      setSidebarAccess(dataItemsAdmin);
      return;
    }

    const filteredItems = filterSidebarItems(dataItemsAdmin, permissions, isSuperAdmin);
    setSidebarAccess(filteredItems);
  }, [userData]);

  return (
    <>
      <nav className={isMenuOpened ? '' : 'nav_show'}>
        <div className={`d-flex side_bar_top ${isMenuOpened ? '' : 'nav_show'}`}>
          <div className="navbar-brand-box">
            <NavLink to="/" className="logo">
              <span className="logo-sm">
                <img src={logoSmall} alt="PSFnetwork Logo" height="40" style={{ objectFit: 'contain', width: 'auto' }} />
              </span>
              <span className="logo-lg">
                <img src={logoFull} alt="PSFnetwork Logo" height="40" style={{ objectFit: 'contain', width: 'auto', maxWidth: '200px' }} />
              </span>
            </NavLink>
          </div>
        </div>
        <ul>
          {sidebarAccess?.map((item, index) => (
            <>
              <li
                className={
                  isMenuOpened
                    ? pathname === item.link
                      ? 'sidebar-nav-item nonActive'
                      : 'sidebar-nav-item nonActive'
                    : pathname === item.link
                    ? 'activeitem'
                    : ''
                }
                onClick={() => {
                  if (item?.nestedtab) {
                    if (nestedIndex === index) setNestedIndex(0);
                    else setNestedIndex(index);
                  } else {
                    if (item.name === 'Logout') {
                      localStorage.clear();
                      window.location.reload();
                      return;
                    }
                    navigate(item.link);
                    setNestedIndex(0);
                  }
                  // openLeftMenuCallBack();
                }}
                key={item.name}
              >
                {item?.nestedtab ? (
                  <a>
                    <i className={item.logo} />
                    {item.name}
                    {nestedIndex === index ? (
                      <i className="uil-angle-up" />
                    ) : (
                      <i className="uil-angle-down" />
                    )}
                  </a>
                ) : (
                  <Link
                    to={item.link}
                    onClick={() => {
                      // openLeftMenuCallBack();
                    }}
                    className={pathname === item.link ? 'color-rgb' : 'color-black'}
                  >
                    <i className={item.logo} />
                    {item.name}
                  </Link>
                )}
              </li>
              {nestedIndex && nestedIndex === index
                ? sidebarAccess[nestedIndex]?.nestedtab?.map(nest => (
                    <li
                      className={
                        isMenuOpened
                          ? pathname === nest.link
                            ? 'sidebar-nav-item nonActive nested-item'
                            : 'sidebar-nav-item nonActive nested-item'
                          : pathname === nest.link
                          ? 'activeitem nested-item'
                          : 'nested-item'
                      }
                      onClick={() => {
                        navigate(nest.link);
                        // openLeftMenuCallBack();
                      }}
                      key={`nested${nest.name}`}
                    >
                      <Link
                        to={nest.link}
                        onClick={() => {
                          // openLeftMenuCallBack();
                        }}
                        className={pathname === nest.link ? 'color-rgb' : 'color-black'}
                      >
                        <i className={nest.logo} />
                        {nest.name}
                      </Link>
                    </li>
                  ))
                : null}
            </>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;
